import { SFNodeType } from '@sciflow/schema';
import { Plugin, PluginKey, EditorState } from 'prosemirror-state';

export const statePluginKey = new PluginKey<{ elements: any[]; }>('state');

const calcElements = (doc) => {
    const elements: any[] = [];
    let i = 1, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;

    const getLabel = (node) => {
        switch (node.type.name) {
            case SFNodeType.heading:
            case SFNodeType.citation:
            case SFNodeType.figure:
            case SFNodeType.code:
                return node.textContent;
            case SFNodeType.math:
                return node.attrs.tex;
        }
    };

    // extract headings
    doc.descendants((node) => {
        //descend into paragraphs and parts
        if (node.type.name === 'paragraph') { return true; }
        if (node.type.name === 'part') { return true; }

        if (node.attrs.id != null) {
            let nodeType = node.type.name === 'figure' ? (node.attrs?.type || node.type.name) : node.type.name;
            let nodeLabel = getLabel(node);
            let index;
            switch (node.type.name) {
                case SFNodeType.figure:
                    {
                        const captionNode = node.content?.content?.find((child) => child.type.name === SFNodeType.caption);
                        const captionText = captionNode?.textContent ? captionNode.textContent.trim() : undefined;
                        const figureType = node.attrs?.type || nodeType;

                        switch (figureType) {
                            case 'table':
                                index = i + j;
                                j++;
                                nodeType = 'table';
                                nodeLabel = captionText || nodeLabel;
                                break;
                            case 'box':
                                index = i + o;
                                o++;
                                nodeType = 'box';
                                nodeLabel = captionText || nodeLabel;
                                break;
                            case 'code':
                                index = i + n;
                                n++;
                                nodeType = 'code';
                                nodeLabel = captionText || nodeLabel;
                                break;
                            default:
                                index = i + k;
                                k++;
                                nodeType = 'figure';
                                nodeLabel = captionText || nodeLabel;
                                break;
                        }
                    }
                    break;
                case SFNodeType.heading:
                    index = i + l;
                    l++;
                    break;
                case SFNodeType.math:
                    index = i + m;
                    m++;
                    nodeType = 'Equation';
                    break;
                case SFNodeType.code:
                    index = i + n;
                    n++;
                    break;
                    
            }
            elements.push({
                type: nodeType, level: node.attrs.level || 1, id: node.attrs.id, label: nodeLabel, pos : index
            });
            return false;
        }

        return true;
    });

    return elements;
};

/*** Calculates state that will be needed outside of the editor instance */
export const statePlugin: Plugin = new Plugin<{ elements: any[]; }>({
    key: statePluginKey,
    state: {
        init(_config, state: EditorState) { return { elements: calcElements(state.doc) }; },
        apply(transaction, oldState: any, newState: EditorState) {
            if (!transaction.docChanged) { return oldState; }
            const elements = calcElements(transaction.doc);
            return { ...oldState, elements };
        },
    }
});
